import { ApplicationRef, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { interval, concat, Observable } from 'rxjs';
import { map, take, first } from 'rxjs/operators';
import { ErrorMsgComponent } from 'src/app/shared/components/error-msg/error-msg.component';

@Injectable({
  providedIn: 'root'
})
export class UpdateMonitorService {
constructor(
    updates: SwUpdate,
    appRef: ApplicationRef,
    private snackBar: MatSnackBar
  ) {
    if (!updates.isEnabled) { return; }

    updates.versionUpdates.subscribe(evt => {
      switch (evt.type) {
        case 'VERSION_DETECTED':
          console.log(`Downloading new app version: ${evt.version.hash}`);
          break;
        case 'VERSION_READY':
          console.log(`Current app version: ${evt.currentVersion.hash}`);
          console.log(`New app version ready for use: ${evt.latestVersion.hash}`);
          this.promptUserToUpdate(evt)
            .pipe(take(1))
            .subscribe(resp => {
              if (resp) {
                updates.activateUpdate().then(() => document.location.reload());
              }
            });
          break;
        case 'VERSION_INSTALLATION_FAILED':
          console.log(`Failed to install app version '${evt.version.hash}': ${evt.error}`);
          break;
      }
    });

    updates.unrecoverable.subscribe(event => {
      this.notifyUser(
        'An error occurred that we cannot recover from:\n' +
        event.reason +
        '\n\nPlease reload the page.'
      );
    });

    const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
    const everySixHours$ = interval(6 * 60 * 60 * 1000);
    const everySixHoursOnceAppIsStable$ = concat(appIsStable$, everySixHours$);

    everySixHoursOnceAppIsStable$.subscribe(() => updates.checkForUpdate());
  }

  private promptUserToUpdate(_: VersionReadyEvent): Observable<boolean> {
    return this.snackBar.open(`An update is available, please reload to install.`, 'Install Now', { duration: 0 })
      .afterDismissed()
      .pipe(map(resp => resp.dismissedByAction));
  }

  private notifyUser(message: string): void {
    this.snackBar.openFromComponent(ErrorMsgComponent, { data: message });
  }
}
